import { Skeleton } from '@components/base';
import { getPermissionFromLocalStorage } from '@helpers/utils';
import css from './index.module.scss';
import { USER_TYPES } from '@helpers/constants';
import { Card, CardHeader } from '@mui/material';

const PeopleSkeleton = () => {
  const userType = getPermissionFromLocalStorage()?.user_type;
  const isInternal = userType === USER_TYPES.internal;
  return isInternal ? (
    <div className={css.peopleSkeletonWrapper}>
      <InternalPeopleSkeleton />
      <InternalPeopleSkeleton />
      <InternalPeopleSkeleton />
      <InternalPeopleSkeleton />
    </div>
  ) : (
    <div className={css.peopleSkeletonWrapper}>
      <Skeleton animation="wave" width={'100%'} height={20} />
      <ExternalPeopleSkeleton />
      <ExternalPeopleSkeleton />
      <ExternalPeopleSkeleton />
      <ExternalPeopleSkeleton />
    </div>
  );
};

const InternalPeopleSkeleton = () => {
  return (
    <div className={css.peopleTabContainer}>
      <Skeleton animation="wave" width={'150px'} height={20} />
      <Skeleton animation="wave" width={'200px'} height={20} />
      <div className={css.cardWrapper}>
        <Card sx={{ maxWidth: 345, minWidth: 250 }}>
          <CardHeader
            avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
            title={
              <Skeleton animation="wave" height={10} width="80%" style={{ marginBottom: 6 }} />
            }
            subheader={<Skeleton animation="wave" height={10} width="40%" />}
          />
        </Card>
        <Card sx={{ maxWidth: 345, minWidth: 250 }}>
          <CardHeader
            avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
            title={
              <Skeleton animation="wave" height={10} width="40%" style={{ marginBottom: 6 }} />
            }
            subheader={<Skeleton animation="wave" height={10} width="80%" />}
          />
        </Card>
      </div>
    </div>
  );
};

const ExternalPeopleSkeleton = () => {
  return (
    <div className={css.peopleTabContainer}>
      <Skeleton animation="wave" width={'150px'} height={20} />
      <div className={css.cardWrapper}>
        <Card sx={{ maxWidth: 345, minWidth: 250 }}>
          <CardHeader
            avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
            title={
              <Skeleton animation="wave" height={10} width="40%" style={{ marginBottom: 6 }} />
            }
            subheader={<Skeleton animation="wave" height={10} width="80%" />}
          />
        </Card>
        <Card sx={{ maxWidth: 345, minWidth: 250 }}>
          <CardHeader
            avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
            title={
              <Skeleton animation="wave" height={10} width="40%" style={{ marginBottom: 6 }} />
            }
            subheader={<Skeleton animation="wave" height={10} width="80%" />}
          />
        </Card>
      </div>
    </div>
  );
};

export default PeopleSkeleton;
